export default {
    name : 'product',

    init()
    {
        const el = document.getElementById('wcProduct');

        const vueData = (typeof window['wcProduct'] === 'object') ? window['wcProduct'] : null;
        // _log(vueData);
        if (el && vueData) {
            this.run(vueData);
        }
    },
    run (vueData)
    {
        window['wcSinglePoduct'] = new Vue({
            el: '#wcProduct',

            delimiters: ['@{','}'],

            data : vueData,

            filters: {
                nok (value, decimal_sep)
                {
                    if (!value) {
                        return null;
                    }

                    value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                    return value + decimal_sep;
                }
            },

            computed : {
                classLightbox ()
                {
                    return (this.lightboxToggled) ? ' active ' : '';
                },

            },

            methods:
            {
                userCanBuyProduct()
                {
                    let canBuy = true;
                    if (this.ap.card.b2xOnly === 'b2b' && !this.isB2B) {
                        canBuy = false;
                        this.restriciontsMessage = 'Dette produktet kan kun kjøpes av forhandlere.';
                    } else if (this.ap.card.b2xOnly === 'b2c' && this.isB2B) {
                        canBuy = false;
                        this.restriciontsMessage = 'Dette produktet kan kun kjøpes av privatkunder.';
                    }

                    return canBuy;
                },

                hasFeaturedTerm(item)
                {
                    if (typeof item === 'undefined') {
                        return false;
                    }

                    return (typeof item.firstFeaturedTerm === 'object' && item.firstFeaturedTerm !== null) ? true : false;
                },

                hasSalesPrice()
                {
                    return (typeof this.ap.card === 'object' && typeof this.ap.card.salesPrice !== 'undefined');
                },

                setAttributesLevel ( level )
                {
                    // _log(level);
                    let set = new Set();

                    if (typeof this.attributes[level] === 'string') {
                        const lv0 = (level===1) ? this.attributes[0] : null;

                        let attr = this.attributes[level];
                        for (let p=0; p< this.variations.length; p++) {

                            // ignore variations
                            if (lv0) {
                                if (typeof this.variations[p].attributes[lv0]!=='string' || this.variations[p].attributes[lv0]!==this.attrLv0) {
                                    continue;
                                }
                            }

                            let theAttr = (typeof this.variations[p].attributes[attr] === 'string') ?
                                        this.variations[p].attributes[attr]  :
                                        null;


                            if (theAttr) {
                                set.add(theAttr);
                            }
                        }
                    }

                    const attribute = 'attributesLv'+level;
                    this[attribute] = set;
                },

                changedLv0 ()
                {
                    this.setAttributesLevel(1);
                    if (this.attrLv0 && (this.attributesLv1===null || this.attributesLv1.size===0)) {
                        this.loadProduct();
                    }
                },

                changedLv1 ()
                {
                    this.loadProduct();
                },

                loadProduct()
                {
                    const product = this.findProductByAttributes();
                    if (product) {
                        const tmpProductId  = this.productId;
                        this.productId      = product.variation_id;
                        this.productAttr    = product.attributes;
                        this.ap             = product;
                        this.updatePrice(product);
                        this.updateGallery(product);
                        // this.updateImage(product);

                        // update query string only on change
                        if (this.productId != tmpProductId) {
                            if (typeof this.productAttr === 'object') {
                                const queryString = httpHuildQuery(this.productAttr);

                                if (queryString) {
                                    window.history.pushState('page2', 'NomaNorge', queryString);
                                }
                            }
                        }
                    }
                },

                updatePrice(product)
                {
                    if (typeof product.card.price_html === 'string' && product.card.price_html.length) {
                        document.getElementById('js_priceHtml').innerHTML = product.card.price_html;
                        this.discountPercentage =  parseInt(product.card.discount);
                    }
                },


                toggleLightbox (index=null)
                {
                    this.lightboxToggled = !this.lightboxToggled;

                    if (this.lightboxToggled) {
                        let lightbox = new Swiper('#js_singleProductImageLightbox', {
                                navigation: {
                                    nextEl: ".swiper-button-next-2",
                                    prevEl: ".swiper-button-prev-2",
                                },
                            });

                        setTimeout(function() {
                            lightbox.slideTo(index);
                        }, 100);
                    }
                },

                updateGallery(product)
                {
                    const initImage = document.getElementById('singleProduct__image--init');
                    if (initImage) {
                        initImage.remove();
                    }

                    this.gallery = [ ...[product.card.image], ...this.productGallery ];
                    setTimeout(this.initSlider, 500);
                },

                initSlider()
                {
                    this.swiper = new Swiper('#js_singleProductImage', {
                        navigation: {
                            nextEl: '.swiper-button-next-1',
                            prevEl: '.swiper-button-prev-1',
                        },
                    });
                },

                slideToIndex(index)
                {
                    this.swiper.slideTo(index);
                },

                findProductByAttributes()
                {
                    // _log('findProductByAttributes');
                    const lv0 = this.attrLv0;
                    const lv1 = this.attrLv1;
                    let product = null;

                    for (let p=0; p<this.variations.length; p++) {
                        let variation = this.variations[p];

                        if (lv0 && !lv1) {
                            // _log('a');
                            if (this.checkProductAttr(variation, 0, lv0)) {
                                product = variation;
                            }
                        } else if (lv0 && lv1) {
                            // _log('b');
                            if (this.checkProductAttr(variation, 0, lv0) && this.checkProductAttr(variation, 1, lv1)) {
                                product = variation;
                            }
                        }

                        if (product) {
                            break;
                        }
                    }

                    return product;
                },

                checkProductAttr(product, attrIndex, required)
                {
                    const attr = this.attributes[attrIndex];
                    return (typeof product.attributes[attr] === 'string' && product.attributes[attr]===required);
                },

                changeVariation ()
                {
                    return false;

                    for (let i=0; i< this.variations.length; i++) {
                        if (this.variations[i].variation_id == this.variationId) {
                            window.location.href = this.variations[i].permalink;
                            break;
                        }
                    }
                },

                changedQty ()
                {
                    if (this.qty <= 0) {
                        this.qty = 1;
                    } else if (this.qty >= 1000) {
                        this.qty = 999;
                    } else {
                        this.qty = parseInt(this.qty);
                    }
                },

                increaseQty ()
                {
                    this.qty += (this.qty < 1000) ? 1 : 0;
                },

                decreaseQty ()
                {
                    this.qty += (this.qty > 1) ? -1 : 0;
                },

                addToCart (e)
                {
                    // _log('product::addToCart');
                    e.preventDefault();

                    this.xhrStatus = 'busy';
                    this.xhrMessage = '';

                    wcRest.addToCart(this.productId,
                                        this.qty,
                                        this.addToCart__callbackSuccess,
                                        this.addToCart__callbackError);
                },

                addToCart__callbackSuccess(response)
                {
                    // _log(response);
                    window['header'].updateCart();
                    this.xhrStatus = 'success';
                },

                addToCart__callbackError(error)
                {
                    // _log("addToCart__callbackError");
                    this.xhrStatus = '';
                    if (error.response) {
                        this.xhrMessage = error.response.data.message.replaceAll('&quot;', "'");
                      _log(error.response.data.message);
                    }
                },

                init ()
                {
                    if (this.hasVariatons) {
                        this.setAttributesLevel(0);
                        this.changedLv0();
                    } else {
                        this.updateGallery({ card : this.card});
                    }

                    document.getElementById('wcProduct').classList.add('isReady');
                }

            },

            created ()
            {
                this.init();
                // _log('wcProduct created');
            }
      });

    }

}